namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailSkupinaFunkciClen extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GSkupinaFunkciClenReadDto;
        private newRecord: boolean;
        private detailObj: DetailSkupinaFunkciClenObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailSkupinaFunkciClenObj());
            this.detailObj.createBase({
                contentName: "detailSkupinaFunkciClen",
                contentCaption: "jres:33000890", //RC 33000890 : P�i�azen� funkce do skupiny funkc�
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailSkupinaFunkciClen", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailSkupinaFunkciClenObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GSkupinaFunkciClenReadDto> {
        openFromFunkcniMisto: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.ixs_sfu_txt} x ${this.data.ixs_fun_txt}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_sfu}#${this.data.ixs_fun}#`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GSkupinaFunkciClenSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            this.cnt.isl.SkupinaFunkciClen.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.openFromFunkcniMisto = this.openFromFunkcniMisto;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailSkupinaFunkciClen", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.SkupinaFunkciClen.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
         }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            if (this.openFromFunkcniMisto) {
                this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ixs_fun=value.ixs_fun",
                    flag: this.createFlagNemenne()
                })
                this.MakeSelectField("ixs_sfu", Gordic.Prefabs.Select.ginssfu(), {
                    model: "model.ixs_sfu=value.ixs_sfu",
                    flag: this.createFlagNemenne()
                })
            } else {
                this.MakeSelectField("ixs_sfu", Gordic.Prefabs.Select.ginssfu(), {
                    model: "model.ixs_sfu=value.ixs_sfu",
                    flag: this.createFlagNemenne()
                })
                this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                    model: "model.ixs_fun=value.ixs_fun",
                    flag: this.createFlagNemenne()
                })
            }
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}
